var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.88525 4.66668L5.57592 6.35735L4.63325 7.30001L1.33325 4.00001L4.63325 0.700012L5.57592 1.64268L3.88525 3.33335H8.66659C10.0811 3.33335 11.4376 3.89525 12.4378 4.89544C13.438 5.89564 13.9999 7.25219 13.9999 8.66668C13.9999 10.0812 13.438 11.4377 12.4378 12.4379C11.4376 13.4381 10.0811 14 8.66659 14H2.66659V12.6667H8.66659C9.72745 12.6667 10.7449 12.2453 11.495 11.4951C12.2452 10.745 12.6666 9.72754 12.6666 8.66668C12.6666 7.60581 12.2452 6.5884 11.495 5.83825C10.7449 5.08811 9.72745 4.66668 8.66659 4.66668H3.88525Z"
  })));
};
export default SvgReply;